<div class="dialog-title">
    <h3> {{'items-requests.Privacy Setting' | translate}}</h3>

    <span mat-button mat-dialog-close>
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <path id="close-ic"
                d="M209,306.662l-4.986,4.986a1.175,1.175,0,1,1-1.662-1.662L207.338,305l-4.986-4.986a1.175,1.175,0,1,1,1.662-1.662L209,303.338l4.986-4.986a1.175,1.175,0,1,1,1.662,1.662L210.662,305l4.986,4.986a1.175,1.175,0,1,1-1.662,1.662Z"
                transform="translate(-202 -298)" fill="#8479ac" />
        </svg>


    </span>



</div>
<mat-dialog-content>
    <div class="register-user">

        <div class="SlideToggle">
            <mat-slide-toggle color="primary" id="slideToggle" [labelPosition]="'before'"
                [(ngModel)]="PrivacySettingToggle">
                <mat-label for="slideToggle"> {{"bidders.Hide your name?"|translate}} </mat-label>
            </mat-slide-toggle>
            <div class="desc">
                {{"bidders.This feature permits you to participate in auctions while keeping your name hidden from other
                bidders."|translate}}
            </div>
            <!-- <label for="slideToggle"> Hide your name? </label> -->

        </div>
        <div class="group_btn">
            <button class="btnLight_fill" mat-button type="submit" mat-dialog-close [disabled]="loading">
                {{'users.CANCEL' | translate}}
            </button>
            <button class="btn_fill" mat-button type="submit" (click)="onSubmit()" [appLoading]="loading">
                {{'users.Submit' | translate}}
            </button>



        </div>


    </div>
</mat-dialog-content>